import { Component } from '@angular/core';

@Component({
	selector: 'abc-spillway',
	templateUrl: './abc-spillway.component.html',
	styleUrls: ['./abc-spillway.component.css']
})

export class AbcSpillwayComponent {}

